import logo from '@assets/logos/logo.svg';
import { useAuthContext } from '@modules/auth/context';
import { Profile } from '@modules/auth/model';
import { sequenceT } from 'fp-ts/Apply';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import React, { FC } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Nav.styles';
import { ActionIcon, Navbar, Text } from '@mantine/core';
import { Logout } from 'tabler-icons-react';
import { useStyles } from '@styles/hooks';

interface NavEntry {
  title: string;
  to: string;
}

interface NavGroup {
  entries: Array<NavEntry>;
}

function getProfileName(profile: Profile): string {
  return pipe(
    sequenceT(O.Apply)(O.fromNullable(profile.firstName), O.fromNullable(profile.lastName)),
    O.fold(
      () => profile.email,
      ([firstName, lastName]) => `${firstName} ${lastName}`,
    ),
  );
}

const entries: Array<NavGroup> = [
  {
    entries: [
      { title: 'Actualités & conseils', to: '/editorials' },
      { title: 'Liens', to: '/links' },
      { title: 'Qui sommes-nous', to: '/about-us' },
      { title: 'Mentions légales', to: '/legals' },
      { title: 'Politique de confidentialité', to: '/gdpr' },
    ],
  },
];

interface NavProps {
  profile: Profile;
}

const Nav: FC<NavProps> = ({ profile }) => {
  const { logout } = useAuthContext();

  const { classes } = useStyles(styles, Nav, undefined);

  return (
    <>
      <Navbar width={{ base: 270 }}>
        <Navbar.Section className={classes.header}>
          <Link to="/">
            <img src={logo} alt="logo" width="100px" />
          </Link>
        </Navbar.Section>

        <Navbar.Section grow className={classes.content}>
          {entries.map((group, i) => (
            <div key={i} className={classes.group}>
              <ul className={classes.entries}>
                {group.entries.map((entry, j) => (
                  <li key={j}>
                    <NavLink to={entry.to} className={({ isActive }) => (isActive ? ' active' : '')}>
                      <div>
                        <span>{entry.title}</span>
                      </div>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </Navbar.Section>

        <Navbar.Section className={classes.footer} p="md">
          <Text size="sm" weight="600" className={classes.profile}>
            {getProfileName(profile)}
          </Text>

          <ActionIcon color="primary" onClick={logout}>
            <Logout size="16" />
          </ActionIcon>
        </Navbar.Section>
      </Navbar>
    </>
  );
};

export default Nav;
